/**
 * Created by alvinoktavianus (https://github.com/alvinoktavianus)
 * on 12/04/18
 */

import React from 'react';
import PropTypes from 'prop-types';
import { currencyFormatter } from 'utils/formatter';
import { PAYMENT_METHOD_LABEL_SHIFT } from 'utils/paymentMethodConstants';
import ShiftDetailRow from '../ShiftDetailRow';

class ShiftDetailEWallet extends React.Component {
  render() {
    const { shift } = this.props;
    return (
      <div className="row">
        <div className="col-lg-12">
          <div className="form-group col-sm-12 label-section">
            <label>E-Wallet</label>
          </div>
          <div className="col-sm-12 card_detail no-padding-right">
            <ShiftDetailRow
              label={PAYMENT_METHOD_LABEL_SHIFT.OVO}
              value={currencyFormatter(shift.total_ovo)}
            />
            <ShiftDetailRow
              label={PAYMENT_METHOD_LABEL_SHIFT.GOPAY}
              value={currencyFormatter(shift.total_gopay)}
            />
            <ShiftDetailRow
              label={PAYMENT_METHOD_LABEL_SHIFT.DANA}
              value={currencyFormatter(shift.total_dana)}
            />
            <ShiftDetailRow
              label={PAYMENT_METHOD_LABEL_SHIFT.TCASH}
              value={currencyFormatter(shift.total_tcash)}
            />
            <ShiftDetailRow
              label={PAYMENT_METHOD_LABEL_SHIFT.KREDIVO}
              value={currencyFormatter(shift.total_kredivo)}
            />
            <ShiftDetailRow
              label={PAYMENT_METHOD_LABEL_SHIFT.AKULAKU}
              value={currencyFormatter(shift.total_akulaku)}
            />
            <ShiftDetailRow
              label={PAYMENT_METHOD_LABEL_SHIFT.ALIPAY}
              value={currencyFormatter(shift.total_alipay)}
            />
            <ShiftDetailRow
              label={PAYMENT_METHOD_LABEL_SHIFT.WECHATPAY}
              value={currencyFormatter(shift.total_wechatpay)}
            />
            <ShiftDetailRow
              label={PAYMENT_METHOD_LABEL_SHIFT.EXPECTED_EWALLET_PAYMENT}
              value={currencyFormatter(shift.expected_ewallet_payment)}
            />
          </div>
        </div>
      </div>
    );
  }
}

ShiftDetailEWallet.propTypes = {
  shift: PropTypes.object,
};

export default ShiftDetailEWallet;
